import moment from 'moment-timezone';
import {
  GLOBAL_SETTINGS_REQUEST,
  GLOBAL_SETTINGS_SUCCESS,
  GLOBAL_SETTINGS_FAILURE,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function globalSettingsRequest() {
  return {
    type: GLOBAL_SETTINGS_REQUEST,
  };
}

function globalSettingsSuccess(data, token = null) {
  return {
    type: GLOBAL_SETTINGS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function globalSettingsError(message) {
  return {
    type: GLOBAL_SETTINGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchGlobalSettings(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(globalSettingsRequest());
    if (!fresh) {
      let globalSettingsData = {};
      try {
        globalSettingsData = JSON.parse(getItem(`${config.get('appName')}.globalSettings`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !globalSettingsData.data ||
        config.get('version') !== globalSettingsData.version ||
        moment().isAfter(moment(globalSettingsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(globalSettingsSuccess(globalSettingsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/settings/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.globalSettings`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(globalSettingsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, globalSettingsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/globalSettings.js